import { React, useState, useEffect, Fragment } from 'react';
import { useLocation, Link, NavLink, useNavigate, Routes } from "react-router-dom";
import { Header, StyledTableRow, StyledTableHeadCell, StyledTableCell, StyledTableFooterCell, NumberFormat, LinearProgressWithLabel } from '../components';
import '../App.css';
import "react-datepicker/dist/react-datepicker.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TextField from "@mui/material/TextField";
import Button from '@material-ui/core/Button';
import { ButtonGroup } from '@mui/material';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { makeStyles } from "@material-ui/core/styles";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import { subMonths } from 'date-fns'
import "react-datepicker/dist/react-datepicker.css";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link as Breadcrumbslink } from '@mui/material';
import { MdOutlineFilterList } from "react-icons/md";

const useStyles = makeStyles({
  root: {
    width: "100%"
  },
  container: {
    maxHeight: "90vh",
    overflowX: 'auto', // Enable horizontal scrolling

  },
  table: {
    minWidth: 800, // Set the minimum width for your table
  },
  TableCell: {
    border: "1px solid rgba(0,0,0,0.2)",
    padding: 4
  }
});

const StockAndGIT_Detail = (props) => {

  const classes = useStyles();

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  let showData = true;

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [StknGITDetailDATA, setstknGITDetailDATA] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  // useEffect(() => {
  //   FetchData()
  // }, [])
  let CCCode = '';
  const fCCCode = state ? state.CcCode : null;
  CCCode = fCCCode ? fCCCode : CCCode;

  useEffect(() => {
    const storedData = localStorage.getItem('StknGITDetailDATA_' + CCCode);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setstknGITDetailDATA(parsedData);
      setFilter(parsedData);
      setProgress(100);
      setLoading(false);
    } else {
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setProgress(0);

    const updateProgress = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(updateProgress);
          return 100;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 800);

    try {
      const response = await fetch(process.env.REACT_APP_SERVER_NAME + '/api/StkInTransitCcDetail?CcCode=' + CCCode); //data source  
      const data = await response.json();
      setstknGITDetailDATA(data);
      setFilter(data);
      localStorage.setItem('StknGITDetailDATA_' + CCCode, JSON.stringify(data));
      setProgress(100);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    } finally {
      clearInterval(updateProgress);
      setLoading(false);
    }
  }

  // const FetchData = async () => {
  //   const data = await fetch(process.env.REACT_APP_SERVER_NAME + '/api/StkInTransitCcDetail?CcCode=' + CCCode); //data source  
  //   const StknGITDetailDATA = showData ? await data.json() : [];
  //   handleStats(StknGITDetailDATA)
  //   setFilter(StknGITDetailDATA);
  // }
  //----TOTAL----------------------
  let total_StockBales = 0;
  let total_StockValue = 0;
  let total_GITBales = 0;
  let total_Containers = 0;
  let total_GITValue = 0;

  StknGITDetailDATA.map((row) => (total_StockBales += row.StockinHand_Qnty,
    total_StockValue += row.StockinHand_Value,
    total_GITBales += row.GITBales,
    total_Containers += row.GITNoOfCont,
    total_GITValue += row.GITValue
  ));

  //---------- Searching-----------------
  const [filter, setFilter] = useState([])
  const [showClearIcon, setShowClearIcon] = useState("none");
  const requestSearch = (searchedVal) => {
    setPage(0);
    setShowClearIcon(searchedVal === "" ? "none" : "flex");
    document.getElementById('searchtext').value = searchedVal === "" ? "" : searchedVal;
    const filteredRows = StknGITDetailDATA.filter((row) => {
      return row.ItemDesc.toString().toLowerCase().includes(searchedVal.toString().toLowerCase())
    });
    if (searchedVal.length < 1) {
      setFilter(StknGITDetailDATA)
    }
    else {
      setFilter(filteredRows)
    }
  };

  //----pagination---------------------
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //-----export pDf---------------------------
  return (
    <>
      {state && (
        <div>
          <div>
            <div className="set-breadcrumb">
              <Breadcrumbs aria-label="breadcrumb">

                <Button onClick={() => { navigate(-1) }} className="hover-underline-animation" style={{ color: 'purple' }}  >Stock & GIT (Summary)</Button>

                <Button disabled={true}> Stock & GIT (Detail) </Button>
              </Breadcrumbs>
            </div>
          </div>
          <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl page">
            <Header category="" title="Stock & GIT (Detail)" OtherInfo={"Description : " + state.CcDesc} />
            <div style={{ marginTop: "-1.5rem" }}>

              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="As On Date"
                  value={AsOnDate}
                  onChange={(newValue) => {
                    if (dayjs(newValue, 'YYYY-MM-DD', true).isValid()) {
                      setAsOnDate(newValue);
                    }
                  }}
                  inputFormat={"DD/MM/YYYY"}
                  renderInput={(params) => <TextField {...params} />}
                  className="sameLineTabledatetime"
                />
              </LocalizationProvider> */}

              {/* <ButtonGroup variant="text" size="" aria-label="outlined primary button group">
                <Button className='filterButton' onClick={getDates}><MdOutlineFilterList size={25} position={10} color='purple' /></Button>
              </ButtonGroup> */}
              {/* <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> */}
              {/* <br /> */}
              <TextField id='searchtext' placeholder="Search" type="text" variant="outlined" fullWidth size="small" onChange={(e) => requestSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => requestSearch("")}
                      style={{ display: showClearIcon }}
                    >
                      <CancelRoundedIcon />
                    </IconButton>
                  )
                }}
              />
            </div>
            {loading && <LinearProgressWithLabel value={progress} />}
            <TableContainer className='table-container'>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead >
                  <TableRow>
                    <StyledTableHeadCell align="left">Description</StyledTableHeadCell>
                    <StyledTableHeadCell align="right">Stock Bales</StyledTableHeadCell>
                    <StyledTableHeadCell align="right">Stock Value $</StyledTableHeadCell>
                    <StyledTableHeadCell align="right">GIT Bales</StyledTableHeadCell>
                    <StyledTableHeadCell align="right">Containers</StyledTableHeadCell>
                    <StyledTableHeadCell align="right">GIT Value $</StyledTableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filter.map((row) => (
                    <StyledTableRow key={row.Id} hover >
                      <StyledTableCell align="left">{row.ItemDesc}</StyledTableCell>
                      <StyledTableCell align="right"><NumberFormat value={row.StockinHand_Qnty} decimal={2} /></StyledTableCell>
                      <StyledTableCell align="right"><NumberFormat value={row.StockinHand_Value} decimal={2} /></StyledTableCell>
                      <StyledTableCell align="right"><NumberFormat value={row.GITBales} decimal={2} /></StyledTableCell>
                      <StyledTableCell align="right"><NumberFormat value={row.GITNoOfCont} decimal={2} /></StyledTableCell>
                      <StyledTableCell align="right"><NumberFormat value={row.GITValue} decimal={2} /></StyledTableCell>
                    </StyledTableRow>
                  ))}
                  <StyledTableRow>
                    <StyledTableFooterCell align="right" style={{ fontWeight: "Bold" }}>Grand Total</StyledTableFooterCell>
                    <StyledTableFooterCell align="right" style={{ fontWeight: "Bold" }}><NumberFormat value={total_StockBales} /></StyledTableFooterCell>
                    <StyledTableFooterCell align="right" style={{ fontWeight: "Bold" }}><NumberFormat value={total_StockValue} /></StyledTableFooterCell>
                    <StyledTableFooterCell align="right" style={{ fontWeight: "Bold" }}><NumberFormat value={total_GITBales} /></StyledTableFooterCell>
                    <StyledTableFooterCell align="right" style={{ fontWeight: "Bold" }}><NumberFormat value={total_Containers} /></StyledTableFooterCell>
                    <StyledTableFooterCell align="right" style={{ fontWeight: "Bold" }}><NumberFormat value={total_GITValue} /></StyledTableFooterCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      )}
    </>
  )
}
export default StockAndGIT_Detail